module.exports = __webpack_public_path__ + "media/dashboard/assets/images/assistents/schedule_review-7535c2864744cd35f5f5be87b22ddbab.png";